/** Mes (1-12) en que empieza una nueva campaña de cosecha. */
const MES_INICIO_CAMPANIA = 3;

/**
 * Código de la cosecha en curso con el formato del backend: `AABB` para la campaña AA/BB.
 * La campaña cambia en marzo: octubre de 2026 y febrero de 2027 corresponden a 2526.
 */
export function cosechaEnCurso(fecha: Date): number {
  const anio = fecha.getFullYear() - (fecha.getMonth() + 1 >= MES_INICIO_CAMPANIA ? 0 : 1);
  return ((anio - 1) % 100) * 100 + (anio % 100);
}

/** Etiqueta legible de un código de cosecha: 2526 → `25/26`; otros valores se muestran tal cual. */
export function cosechaLabel(codigo: number): string {
  const texto = String(codigo);
  const match = /^(\d{2})(\d{2})$/.exec(texto);
  return match && (Number(match[1]) + 1) % 100 === Number(match[2]) ? `${match[1]}/${match[2]}` : texto;
}

/** Cosecha en curso y las dos anteriores, para un filtro de selección. */
export function cosechasRecientes(fecha: Date, cantidad = 3): number[] {
  const actual = cosechaEnCurso(fecha);
  return Array.from({ length: cantidad }, (_, i) => actual - i * 101);
}
